import { Component, OnInit } from '@angular/core';
import { getUsersSelector, getUsersStatsSelector } from '../users.reducer';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'cc-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {
  public userStats;
  public userList;
  public user;
  public id;
  public state;

  constructor(private store: Store<IState>, private route: ActivatedRoute) {}

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.state = this.route.parent.snapshot.paramMap.get('state');

    this.store.select(getUsersStatsSelector).subscribe(userStats => (this.userStats = userStats));
    this.store.select(getUsersSelector).subscribe(userList => {
      this.userList = userList;
      this.user = userList.find(
        user =>
          Number(this.id) !== 0 || this.state === 'all'
            ? user.username === this.id || user.uniqueId === parseInt(this.id, 10)
            : user.state.toLowerCase() === this.state
      );
    });
  }
}
